import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mg-menu-item-wrapper divider--line"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("li", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("span", {
    class: "mg-menu-divider-line"
  }, null, -1)]))]);
}